import { useRef, useState } from "react";
import { CyberpassInput, CyberpassPhoneInput } from "../Input";
import { useSearchParams } from "react-router-dom";
import { getOrDefault } from "../common/optional";
import Modal from "../Modal";
import { useTranslation } from "../i18n";

const HOST = import.meta.env.VITE_API_HOST;

/**
 * @returns {React.Component}
 */
export default function UserRegistration() {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [searchParams] = useSearchParams();

  const defaultFormData = {
    firstname: getOrDefault(searchParams.get("firstname"), ""),
    lastname: getOrDefault(searchParams.get("lastname"), ""),
    phone: getOrDefault(searchParams.get("phone"), "+7"),
    telegram_username: getOrDefault(searchParams.get("telegram_username"), ""),
  };

  console.log([...searchParams.values()]);

  const [formData, setFormData] = useState({ ...defaultFormData });
  /** @type {React.MutableRefObject<HTMLFormElement>} */
  const formRef = useRef(null);

  /**
   * @param {Event} event
   * @returns {void}
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    setShowModal(true);
  };

  /**
   * @param {Event & { phone: String }} event
   * @returns {void}
   */
  const handleInputChange = (event) => {
    if (event.phone) {
      console.log(event);
      setFormData({
        ...formData,
        phoneNumber: event.phone,
      });
    } else {
      const { name, value } = event.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  function confirmRegistration() {
    const request = {
      firstname: formData.firstname,
      lastname: formData.lastname,
      phone_number: formData.phone_number,
      telegram_username: formData.telegram_username,
    };

    console.log("Sending registration request:", request);

    fetch(`${HOST}/api/v1/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request),
    })
      .then((resp) => {
        console.log("SUCCESS");
        setFormData({ ...defaultFormData });
        return resp.json();
      })
      .then(() => {
        console.log("Form data submitted:", formData);
        formRef.current.reset();
      })
      .catch((e) => {
        alert(t("registration.userExists"));
        console.error(e);
      });
  }

  return (
    <form
      onSubmit={handleSubmit}
      ref={formRef}
      className="bg-gray-800 rounded-lg p-4"
    >
      <div className="grid gap-6 mb-6">
        <CyberpassInput
          type="text"
          name="firstname"
          id="first_name"
          label={t("registration.firstname")}
          placeholder={t("registration.firstnamePlaceholder")}
          onChange={handleInputChange}
          value={formData.firstname}
          required={true}
        />
        <CyberpassInput
          type="text"
          name="lastname"
          id="last_name"
          label={t("registration.lastname")}
          placeholder={t("registration.lastnamePlaceholder")}
          onChange={handleInputChange}
          value={formData.lastname}
          required={true}
        />
        <CyberpassPhoneInput
          name="phone"
          id="phone_number"
          label={t("registration.phone")}
          placeholder="+77777777777"
          onChange={handleInputChange}
          value={formData.phone_number}
          required={true}
        />
        <CyberpassInput
          name="telegram_username"
          id="telegram_username"
          label={t("registration.telegram")}
          placeholder="@username"
          onChange={handleInputChange}
          value={formData.telegram_username}
          required={true}
        />
      </div>
      <div className="flex justify-end">
        <button
          type="submit"
          className="md:text-4xl text-white bg-purple-700 hover:bg-purple-800 focus:ring-4 focus:outline-none focus:ring-purple-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-800"
        >
          {t("common.confirm")}
        </button>
      </div>
      <Modal
        title={t("registration.confirmTitle")}
        content=<h1>Test content</h1>
        showModal={showModal}
        setShowModal={setShowModal}
        setModalConfirmed={confirmRegistration}
      />
    </form>
  );
}
